module.exports = __webpack_public_path__ + "static/media/fa-light-300.6b1c4bcb.woff2";